import { render, staticRenderFns } from "./BonusesAndPenalties.vue?vue&type=template&id=58e608b5&scoped=true"
import script from "./BonusesAndPenalties.vue?vue&type=script&lang=ts"
export * from "./BonusesAndPenalties.vue?vue&type=script&lang=ts"
import style0 from "./BonusesAndPenalties.vue?vue&type=style&index=0&id=58e608b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e608b5",
  null
  
)

export default component.exports